
/*--------------------------------------------------------------------------------------------
Program     :  Maptrackcontext.js
Description :  Main context program for Map and Track
Date        :  29/08/2024 
Created By  :  Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
29082024        - Jelbin     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import { createContext, useContext, useState } from "react";

const Maptrackcontext = createContext();

export function useMapTrackInfo() {
  return useContext(Maptrackcontext);
}

export function MapTrackProvider({ children }) {
  const [dataModified, setDataModified] = useState(false);
  const [selectedChooseData, setSelectedChooseData] = useState([])
  const [combinedData, setCombinedData] = useState([]);
  const [timeATPOI, setTimeATPOI] = useState("");
  const [dlgPOIopen, setdlgPOIopen] = useState(false);
  const [dlgopen, setdlgOpen] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [note, setNote] = useState("");
  const [noteData, setnoteData] = useState();
  const [travelerName, setravelerName] = useState();
  const [POIExist, setPOIExist] = useState(false);
  const [reassignMapData, setReassignMapData] = useState([]);
  const [sourceIndexVal, setSourceIndexVal] = useState(0);
  const [oldSourceindex, setoldSourceindex] = useState(0);
  const [noteLocalSave,setNoteLocalSave] = useState([]);
  const [tableUniqueValue,settableUniqueValue] = useState("");
  const [poiData, setPOIData] = useState([]);
  const [reSearch, setResearch] = useState(false);
  const [participantsFields,setparticipantsFields] = useState([]);
  const [participantsTimeFields,setparticipantsTimeFields] = useState([]);
  const [mergeparticipantFields,setmergeparticipantFields] = useState([]);
  const [envFileData,setEnvFileData] = useState("");
  const [forMinTime,setForMinTime] = useState(0);
  const [trvlTimePercnt,setTrvlTimePercnt] = useState(0);
  const [startsave, setStartsave] = useState(false);
  const [selectedTaskVal, setselectedTaskVal] = useState({});
  const [selectedCalenderTaskVal,setselectedCalenderTaskVal] = useState({});
  const [taskClicked,settaskClicked] = useState(false);
  const [participantTaskTime,setParticipantTaskTime] = useState([]);
  const [openCalender,setOpenCalender] = useState(false);
  const [holidayPayload,setHolidayPayload] = useState([]);
  const [selectedCalenderTaskDate, setselectedCalederTaskDate] = useState("");
  const [fielduserHide, setfielduserHide] = useState("");
  const [finalTravelTimeData, setFinalTravelTimeData] = useState([]);
  const [userOrPOIchange, setUserOrPOIchange] = useState(false);
  const [onlyuserChange, setonlyUserChange] = useState(false);
  const [savedata, setSaveData] = useState(false);
  const [basePayload, setbasePayload] = useState([]);
  const [startPayloadCompare, setStartPayloadCompare] = useState(false);
  const [startTrvlTimeCalculte, setStartTrvlTimeCalculte] = useState(false);
  const [comparedPayload, setComparedPayload] = useState([]);
  const [travelTimeLoader,setTravelTimeLoader] = useState(false);
  const [travelbuttonEnable,setTravelbuttonEnable] = useState(false);
  const [savebuttonEnable,setSavebuttonEnable] = useState(false);
  const [userReadOnly, setUserReadOnly] = useState("");
  const [agentColor, setagentColor] = useState("");

  return (
    <Maptrackcontext.Provider
      value={{ dataModified, setDataModified,selectedChooseData, setSelectedChooseData,
        combinedData, setCombinedData,timeATPOI,setTimeATPOI,dlgPOIopen, setdlgPOIopen,
        dlgopen, setdlgOpen,messageData, setMessageData,noteData, setnoteData,note, setNote,
        travelerName, setravelerName,POIExist, setPOIExist,reassignMapData, setReassignMapData,
        sourceIndexVal, setSourceIndexVal,oldSourceindex,setoldSourceindex,noteLocalSave,
        setNoteLocalSave,tableUniqueValue,settableUniqueValue,poiData,setPOIData,reSearch, 
        setResearch,participantsFields,setparticipantsFields,participantsTimeFields,
        setparticipantsTimeFields,mergeparticipantFields,setmergeparticipantFields,envFileData,setEnvFileData,
        forMinTime,setForMinTime,trvlTimePercnt,setTrvlTimePercnt,startsave,setStartsave,
        selectedTaskVal, setselectedTaskVal,selectedCalenderTaskVal,setselectedCalenderTaskVal,taskClicked,
        settaskClicked,participantTaskTime,setParticipantTaskTime,openCalender,setOpenCalender,
        holidayPayload,setHolidayPayload,selectedCalenderTaskDate, setselectedCalederTaskDate,
        fielduserHide,setfielduserHide,finalTravelTimeData,setFinalTravelTimeData,
        userOrPOIchange,setUserOrPOIchange,onlyuserChange, setonlyUserChange,savedata,setSaveData,
        basePayload, setbasePayload,startTrvlTimeCalculte, setStartTrvlTimeCalculte,
        startPayloadCompare, setStartPayloadCompare,comparedPayload, setComparedPayload,
        travelTimeLoader,setTravelTimeLoader,travelbuttonEnable,setTravelbuttonEnable,
        savebuttonEnable,setSavebuttonEnable,userReadOnly, setUserReadOnly,
        agentColor, setagentColor}}
    >
      {children}
    </Maptrackcontext.Provider>
  );
}